if(!customElements.get('featured-blog-posts')){
    class FeaturedBlogPosts extends HTMLElement {
        constructor(){
            super();

            this.columnType = this.dataset.columnType;
            this.buttonBlogs = this.querySelectorAll('.button-blog');
            this.blogContents = this.querySelectorAll('.blog__content');
        }

        connectedCallback(){
            if(this.buttonBlogs){
                this.buttonBlogs.forEach(item => {
                    item.addEventListener("click", this.changeBlogPosts.bind(this));
                    item.addEventListener("keydown", e => {
                        if(e.key === 'Enter'){
                            this.changeBlogPosts(e);
                        }
                    });
                });
            }
            
            if(this.columnType === 'slideshow'){
                this.initializeSwipers();
            }
        }

        async initializeSwipers(){
            this.swiperContainers = this.querySelectorAll('.swiper-container');
            if(this.swiperContainers.length === 0) return;

            if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }

            this.swiperContainers.forEach(swiperContainer => {
                this.initializeSwiper(swiperContainer);
            });
        }

        initializeSwiper(swiperContainer){
            const slides = swiperContainer.querySelectorAll('.swiper-slide');
            if(slides.length <= 1) return;

            const itemsPerView = parseInt(swiperContainer.dataset.itemsPerView);
            const itemsPerViewMobile = parseInt(swiperContainer.dataset.itemsPerViewMobile);
            const totalSlides = swiperContainer.dataset.itemsTotal;
            const autoplay = swiperContainer.dataset.autoplay === 'true';
            const speed = parseInt(swiperContainer.dataset.speed);
            const loop = swiperContainer.dataset.loop === 'true';
            const visibleItemsPerView = (itemsPerView && totalSlides > itemsPerView)? itemsPerView : totalSlides;
            const spaceBetween = parseInt(swiperContainer.dataset.gap);

            const breakpoints = {
                0: { slidesPerView: itemsPerViewMobile },
                768: { slidesPerView: visibleItemsPerView }
            }

            const parent = swiperContainer.closest('.blog__content');
            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: breakpoints,
                observer: true,
                observeSlideChildren: true,
                watchSlidesProgress: true,
                autoHeight: false,
                spaceBetween: spaceBetween,
                on: {
                    init: () => {
                        if(!parent) return;
                        const paginationBullets = parent.querySelectorAll(".swiper-pagination-bullet");
                        if(paginationBullets.length > 0){
                            parent.style.setProperty('--pagination-width', `calc(100% / ${paginationBullets.length})`);
                            paginationBullets.forEach((item, index) => {
                                item.setAttribute('data-index', `${index}`);
                            });
                            setTimeout(() => {
                                parent.querySelector('.swiper-pagination')?.classList.add('loaded');
                                this.checkSwiperLock(parent, swiper);
                            }, 500);
                        }
                    },
                    slideChange: () => {
                        if(!parent) return;

                        const activePagination = parent.querySelector(".swiper-pagination-bullet-active");
                        if(activePagination){
                            const activePaginationIndex = parseInt(activePagination.dataset.index);
                            parent.style.setProperty('--pagination-translate-x', `calc(100% * ${activePaginationIndex})`);
                        }
                    }
                }
            }

            if(swiperContainer.querySelector(".swiper-navigation-wrapper")){
                swiperSettings.navigation = {
                    nextEl: swiperContainer?.querySelector('.button-next'),
                    prevEl: swiperContainer?.querySelector('.button-previous')
                }
            }

            if(parent.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                    el: parent.querySelector('.swiper-pagination')
                }
            }

            if(autoplay && !isNaN(speed)){
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            const swiper = new Swiper(swiperContainer, swiperSettings);
            swiper.init();

            swiper.on("resize", () => { this.checkSwiperLock(parent, swiper) });

            this.setupFocusListeners();
        }

        checkSwiperLock(parent, swiper){
            if(!swiper) return;
            if(!parent.querySelector(".swiper-pagination")) return;

            if(swiper.isLocked){
                parent.querySelector(".swiper-pagination").classList.add("hidden");
            }else{
                parent.querySelector(".swiper-pagination").classList.remove("hidden");
            }
        }

        setupFocusListeners(){
            this.querySelectorAll(".button-next, .button-previous").forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');
                    button.addEventListener('blur', () => {
                        button.classList.remove('focused');
                    }, { once: true });
                });
            });
        }

        changeBlogPosts(e){
            if(!e.currentTarget) return;

            const currentButtonBlog = e.currentTarget;

            this.buttonBlogs.forEach(item => { item.classList.remove('active') });
            currentButtonBlog.classList.add('active');

            const currentBlogIndex = e.currentTarget.dataset.blogIndex;
            if(currentBlogIndex){
                this.blogContents.forEach(item => {
                    if(item.dataset.blogIndex === currentBlogIndex){
                        item.setAttribute('data-hidden', 'false');
                        item.removeAttribute('inert');
                        item.querySelectorAll('.in-view').forEach(i => {
                            i.classList.remove('in-view');
                            setTimeout(() => {
                                i.classList.add('in-view');
                            }, 0);
                        });
                    }else{
                        item.setAttribute('data-hidden', 'true');
                        item.setAttribute('inert', '');
                    }
                });
            }

            // read more button
            this.querySelectorAll('.button-read-more').forEach(item => {
                if(currentBlogIndex === item.dataset.blogIndex){
                    item.setAttribute('data-hidden', 'false');
                    item.removeAttribute('inert');
                }else{
                    item.setAttribute('data-hidden', 'true');
                    item.setAttribute('inert', '');
                }
            });
        }
    }

    customElements.define('featured-blog-posts', FeaturedBlogPosts);
}